import UserTagsProvider from './UserTagsProvider'

export default UserTagsProvider

export { useUserTags } from './UserTagsContext'
